import MenuItemIcon from '../components/MenuItemIcon';
import InputTextComponent from '../components/inputs/InputTextComponent';
import InputDropdownComponent from '../components/inputs/InputDropdownComponent';
import InputRadioButtonComponent from '../components/inputs/InputRadioButtonComponent';
import InputCalendarComponent from '../components/inputs/InputCalendarComponent';
import moment from 'moment';
import TooltipComponent from '../components/TooltipComponent';
import React from 'react';
import DivContainer from '../components/DivContainer';
export const OwnDeliveryContainer = (props) => {
    const {
        agreementEmail,
        carrierEmail,
        deliveryPlaces,
        t,
        summary,
        element,
        validator,
        handleChange,
        orderTypeOptions,
        ownDeliverPurposeTypeOpt,
        fuelBases,
        onAfterTransportTypeChange,
        onAfterPurposeChange,
        handleHideTooltip,
        handleShowTooltip,
        handleShowTooltipMenuItem,
        onTooltipClick,
        sentNumberTooltipVisibile,
        templateEdit,
    } = props;
    return (
        <React.Fragment>
            <div className='row'>
                <InputDropdownComponent
                    id='orderType-dropdown'
                    name='orderType'
                    label={summary ? t('order-fuel.deliveryReception') : t('order-fuel.orderType')}
                    colClass='col-md-4 col-sm-12'
                    value={element.orderType}
                    viewMode={summary ? 'VIEW' : 'EDIT'}
                    enumMode
                    enumName='OrderType'
                    validator={validator}
                    validators='required'
                    options={orderTypeOptions}
                    onChange={handleChange}
                    optionValue='enumValue'
                    dataKey='enumValue'
                    optionLabel='label'
                    disabled
                    renderValue={
                        summary
                            ? () => {
                                  return element.orderType ? (
                                      <label className='black-labels'>{t(`OrderType.${element.orderType}`)}</label>
                                  ) : (
                                      <label />
                                  );
                              }
                            : null
                    }
                />

                {templateEdit ? null : (
                    <InputCalendarComponent
                        id='deliveryDate'
                        name='deliveryDate'
                        label={t('order-fuel.deliveryDate')}
                        dateFormatMoment='DD-MM-YYYY'
                        colClass='col-md-4 calendar-icon-white-bg'
                        value={element.deliveryDate}
                        validator={validator}
                        validators={`required|date|date_format:DD-MM-YYYY,dd-mm-rrrr|after_or_equal:${moment(new Date()).format(
                            'DD-MM-YYYY'
                        )}|`}
                        onChange={handleChange}
                        viewMode={summary ? 'VIEW' : 'EDIT'}
                        showIcon
                        minDate={new Date()}
                        renderValue={
                            summary
                                ? () => {
                                      return element.deliveryDate ? (
                                          <React.Fragment>
                                              <label className='black-labels flex-inputs'>
                                                  {moment(element.deliveryDate).format('DD-MM-YYYY')}
                                              </label>
                                              <label className='white-labels flex-inputs'>
                                                  {t(`weekDays.${element.deliveryDate.getDay()}`)}
                                              </label>
                                          </React.Fragment>
                                      ) : (
                                          <label />
                                      );
                                  }
                                : null
                        }
                    />
                )}
                {summary ? (
                    <InputRadioButtonComponent
                        id='transportType'
                        name='transportType'
                        label={t('order-fuel.transportTypeSummaryLabel')}
                        colClass='col-md-4'
                        viewMode={'VIEW'}
                        valueLabel='label'
                        options={[]}
                        itemColClass={'col-md-6 col-sm-12'}
                        renderValue={() => {
                            return element.transportType ? (
                                <span className='p-inputtext-view'>
                                    <label className='white-labels flex-inputs'>{t(`TransportType.${element.transportType}`)}</label>
                                </span>
                            ) : (
                                <label />
                            );
                        }}
                        rendered={!(element?.purpose === 'NO_SENT_TRX')}
                    />
                ) : null}
                {/* transportTypeSummaryLabel */}
            </div>
            <div className='row'>
                <InputDropdownComponent
                    id='purpose'
                    name='purpose'
                    label={t('order-fuel.purpose')}
                    colClass='col-md-4 col-sm-12'
                    value={element.purpose}
                    viewMode={summary ? 'VIEW' : 'EDIT'}
                    validator={validator}
                    validators='required'
                    options={ownDeliverPurposeTypeOpt}
                    onChange={handleChange}
                    optionLabel='label'
                    enumMode
                    enumName='PurposeType'
                    optionValue='enumValue'
                    dataKey='enumValue'
                    renderValue={
                        summary
                            ? () => {
                                  return element.purpose ? (
                                      <label className='black-labels'>{t(`PurposeType.${element.purpose}`)}</label>
                                  ) : (
                                      <label />
                                  );
                              }
                            : null
                    }
                    onAfterStateChange={onAfterPurposeChange}
                />
                <InputTextComponent
                    id='sentKeyEmail'
                    name='email'
                    label={t('order-fuel.sentKeyEmail')}
                    colClass='col-md-4 col-sm-12'
                    value={agreementEmail}
                    viewMode={summary ? 'VIEW' : 'EDIT'}
                    validator={validator}
                    validators='required'
                    onChange={handleChange}
                    disabled
                    rendered={!(element?.purpose === 'NO_SENT_TRX')}
                    renderValue={
                        summary
                            ? () => {
                                  return agreementEmail ? <label className='white-labels'>{agreementEmail}</label> : <label />;
                              }
                            : null
                    }
                    renderLabel={() => (
                        <div className='tooltip-label'>
                            <TooltipComponent
                                id='sentKeyEmail-tooltip-label-id'
                                key='sentKeyEmail-tooltip-label-id'
                                onClick={onTooltipClick}
                                visible={sentNumberTooltipVisibile}
                                content={t('order-fuel.sentNumberTooltip')}
                                eventListeners={[
                                    {
                                        eventName: 'mouseleave',
                                        fnc: handleHideTooltip,
                                        eventElementId: 'ico_help_input_label_id',
                                    },
                                    {
                                        eventName: 'mouseenter',
                                        fnc: handleShowTooltip,
                                        eventElementId: 'ico_help_input_label_id',
                                    },
                                ]}
                            />
                            <span className='row '>
                                <label id='sentKeyEmail-label-id' className='p-label flex-inputs ' htmlFor={'sentKeyEmail-label-id'}>
                                    {t('order-fuel.sentKeyEmail')}
                                </label>
                                <MenuItemIcon
                                    alt=''
                                    key={'menu-item-key'}
                                    id='ico_help_input_label_id'
                                    className='icon-svg right-label flex-inputs'
                                    iconSvg={'ico_help_input_label'}
                                    eventListeners={[
                                        {
                                            eventName: 'mouseenter',
                                            fnc: handleShowTooltipMenuItem,
                                            eventElementId: 'ico_help_input_label_id',
                                        },
                                    ]}
                                />
                            </span>
                        </div>
                    )}
                />

                <InputTextComponent
                    id='carrierEmail'
                    name='carrierEmail'
                    label={t('order-fuel.carrierEmail')}
                    colClass='col-md-4 col-sm-12'
                    value={carrierEmail}
                    viewMode={summary ? 'VIEW' : 'EDIT'}
                    validator={validator}
                    validators='required'
                    onChange={handleChange}
                    disabled
                    rendered={!!summary && element.transportType === 'RENTED'}
                    renderValue={
                        summary
                            ? () => {
                                  return carrierEmail ? <label className='white-labels'>{carrierEmail}</label> : <label />;
                              }
                            : null
                    }
                    renderLabel={() => (
                        <div className='tooltip-label'>
                            <TooltipComponent
                                id='carrierEmail-tooltip-label-id'
                                key='carrierEmail-tooltip-label-id'
                                onClick={onTooltipClick}
                                visible={sentNumberTooltipVisibile}
                                content={t('order-fuel.sentNumberTooltip')}
                                eventListeners={[
                                    {
                                        eventName: 'mouseleave',
                                        fnc: handleHideTooltip,
                                        eventElementId: 'ico_help_input_label_id',
                                    },
                                    {
                                        eventName: 'mouseenter',
                                        fnc: handleShowTooltip,
                                        eventElementId: 'ico_help_input_label_id',
                                    },
                                ]}
                            />
                            <span className='row '>
                                <label id='carrierEmail-label-id' className='p-label flex-inputs ' htmlFor={'carrierEmail-label-id'}>
                                    {t('order-fuel.carrierEmail')}
                                </label>
                                <MenuItemIcon
                                    alt=''
                                    key={'menu-item-key'}
                                    id='ico_help_input_label_id'
                                    className='icon-svg right-label flex-inputs'
                                    iconSvg={'ico_help_input_label'}
                                    eventListeners={[
                                        {
                                            eventName: 'mouseenter',
                                            fnc: handleShowTooltipMenuItem,
                                            eventElementId: 'ico_help_input_label_id',
                                        },
                                    ]}
                                ></MenuItemIcon>
                            </span>
                        </div>
                    )}
                />
                <InputTextComponent
                    id='sentNumber'
                    name='sentNumber'
                    label={t('order-fuel.sentNumber')}
                    colClass='col-md-4 col-sm-12'
                    value={element.sentNumber}
                    viewMode={summary ? 'VIEW' : 'EDIT'}
                    validator={validator}
                    validators='required'
                    onChange={handleChange}
                    rendered={element?.purpose === 'RESALE'}
                    renderValue={
                        summary
                            ? () => {
                                  return element.sentNumber ? <label className='white-labels'>{element.sentNumber}</label> : <label />;
                              }
                            : null
                    }
                />
                <DivContainer colClass='col-md-4' rendered={element?.purpose === 'NO_SENT_TRX'} />
                <InputDropdownComponent
                    id='werks'
                    name='werks'
                    label={t('order-fuel.werks')}
                    colClass='col-md-8 col-sm-12'
                    value={element.werks}
                    viewMode={summary ? 'VIEW' : 'EDIT'}
                    validator={validator}
                    validators='required'
                    options={fuelBases}
                    onChange={handleChange}
                    filter
                    filterBy='name'
                    dataKey='sapId'
                    optionLabel='name'
                    renderValue={
                        summary
                            ? () => {
                                  return element.werks ? <label className='black-labels'>{element.werks['address']}</label> : <label />;
                              }
                            : null
                    }
                />
                <InputDropdownComponent
                    id='partner'
                    name='partner'
                    label={t('order-fuel.partner')}
                    colClass='col-md-8 col-sm-12'
                    value={element.partner}
                    viewMode={summary ? 'VIEW' : 'EDIT'}
                    validator={validator}
                    validators='required'
                    options={deliveryPlaces}
                    onChange={handleChange}
                    dataKey='sapId'
                    optionLabel='address'
                    renderValue={
                        summary
                            ? () => {
                                  return element?.partner?.address ? (
                                      <label className='black-labels'>{element.partner['address']}</label>
                                  ) : (
                                      <label />
                                  );
                              }
                            : null
                    }
                    rendered={element.purpose === 'NO_SENT_TRX' || element.purpose === 'OWN_STATION'}
                />
                {!summary ? (
                    <InputRadioButtonComponent
                        id='transportType'
                        name='transportType'
                        label={t('order-fuel.transportType')}
                        colClass='col-md-8 col-sm-12'
                        value={element.transportType}
                        viewMode={'EDIT'}
                        labelOnRight
                        onChange={handleChange}
                        options={[
                            {enumValue: 'OWN', label: t('TransportType.OWN')},
                            {enumValue: 'RENTED', label: t('TransportType.RENTED')},
                        ]}
                        validator={validator}
                        valueLabel='label'
                        valueKey='enumValue'
                        itemColClass={'col-md-6 col-sm-12'}
                        validators='required'
                        onAfterStateChange={onAfterTransportTypeChange}
                    />
                ) : null}
            </div>
        </React.Fragment>
    );
};
